import { getAxiosInstance } from "../../../api";


export const downloadActivityLog = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/internal-reports/export-activity-log-report`,
      params
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};


export const deleteActivityLog = async () => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/internal-reports/delete-activity-log
` );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

